import {
    AdapterRegistry,
    Metamodel,
    NamedAsyncAdapter,
    type IPbiNotebookEntity,
    type ITridentResource,
    PbiNotebook,
    ModelConstants
} from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PbiNotebook),
    asynchronous: true
})
export class PbiNotebookAdapter extends NamedAsyncAdapter<PbiNotebook, IPbiNotebookEntity> {
    protected async _toResource(notebook: PbiNotebook): Promise<IPbiNotebookEntity> {
        // We will never care about converting this model to a resource
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {} as IPbiNotebookEntity;
    }

    protected async _toModel(resource: IPbiNotebookEntity, model?: PbiNotebook): Promise<PbiNotebook> {
        model.objectId = resource.objectId;
        model.displayName = resource.name;
        model.workspaceId = resource?.properties?.typeProperties.workspace;

        return model;
    }

    protected override async _toAzureResource(tridentResource: ITridentResource): Promise<IPbiNotebookEntity> {
        return {
            id: `/subscriptions/xxxxxxxxx/resourceGroups/xxxx/providers/Microsoft.DataFactory/factories/xxxxxxx/pbinotebooks/${tridentResource.displayName}`,
            name: tridentResource.displayName,
            objectId: tridentResource.objectId,
            workspaceObjectId: tridentResource.workspaceObjectId,
            properties: {
                type: ModelConstants.pbiNotebook,
                typeProperties: {
                    workspace: tridentResource.workspaceObjectId
                }
            }
        };
    }
}
